import { render } from "./listarPedidos.vue?vue&type=template&id=5d161cdb&scoped=true"
import script from "./listarPedidos.vue?vue&type=script&lang=js"
export * from "./listarPedidos.vue?vue&type=script&lang=js"

import "./listarPedidos.vue?vue&type=style&index=0&id=5d161cdb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d161cdb"]])

export default __exports__